import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../i18n/constants/keys';
import { Tabs } from '../../../../../ui';
import { ToggleInput } from '../../../../../ui/input/toggle_input/toggle_input';
import { Assessment } from '../../../../../utils/types/assessment_types';
import CCATab from './CCATab';
import { useJobPostingTabs } from './Hooks/UseJobPostingTabs';
import { IJobPostingTabs } from './Interfaces/IJobPostingTabs';
import JobPostDetails from './JobPostDetails';
import JobPostSettings from './JobPostSettings';
import PreQualifyingQuestions from './PreQualifyingQuestions';
import { JobPostingPreview } from './Preview';
import VideoMessageDetails from './VideoMessageDetails';
import { JobPostConfig } from './JobPostConfig';

const JobPosting = ({
  jobTitleList,
  jobDescription,
  jobPostingData,
  setJobPostingData,
  jobPostExist,
  setStages,
  autoAssessment,
  selectedCompanyId,
}: IJobPostingTabs) => {
  const {
    activeTab,
    setActiveTab,
    tabTitles,
    jobPostId,
    setJobPostId,
    orgPerksAndBenefits,
    setOrgPerksAndBenefits,
    orgCompanyDetails,
    setOrgCompanyDetails,
    orgNames,
    handleToggle,
    hasCCALicense,
  } = useJobPostingTabs({
    jobTitleList,
    jobDescription,
    jobPostingData,
    setJobPostingData,
    jobPostExist,
    setStages,
    autoAssessment,
    selectedCompanyId,
  });
  const { t } = useTranslation(NS.adminPages);
  const [assessmentInfo, setAssessmentInfo] = useState<Assessment | undefined>(
    autoAssessment?.assessment,
  );
  const renderTab = () => {
    if (activeTab === 'jobPostConfig') {
      return (
        <JobPostConfig
          jobTitleList={jobTitleList}
          jobDescription={jobDescription}
          jobPostingData={jobPostingData}
          setJobPostingData={setJobPostingData}
          setActiveTab={setActiveTab}
          setJobPostId={setJobPostId}
          jobPostId={jobPostId}
          orgPerksAndBenefits={orgPerksAndBenefits}
          setOrgPerksAndBenefits={setOrgPerksAndBenefits}
          orgCompanyDetails={orgCompanyDetails}
          setOrgCompanyDetails={setOrgCompanyDetails}
          orgNames={orgNames}
          hasCCALicense={hasCCALicense}
          assessmentInfo={assessmentInfo}
          setAssessmentInfo={setAssessmentInfo}
        />
      );
    } else if (activeTab === 'jobPostDetails') {
      return (
        <JobPostDetails
          setActiveTab={setActiveTab}
          jobPostingData={jobPostingData}
          setJobPostingData={setJobPostingData}
          jobDescription={jobDescription}
          orgPerksAndBenefits={orgPerksAndBenefits}
          setOrgPerksAndBenefits={setOrgPerksAndBenefits}
          orgCompanyDetails={orgCompanyDetails}
          setOrgCompanyDetails={setOrgCompanyDetails}
          orgNames={orgNames}
          jobPostId={jobPostId}
          setJobPostId={setJobPostId}
          setStages={setStages}
        />
      );
    }
  };

  return (
    <div className='min-w-0'>
      <div className='flex w-full min-w-0 flex-col gap-3 lg:flex-row lg:items-center lg:justify-between'>
        <Tabs
          tabs={tabTitles}
          activeTab={activeTab}
          onTabChange={(tabValue) => {
            setActiveTab(tabValue);
          }}
        />
        <div className='flex justify-start lg:justify-end'>
          <div className='flex flex-wrap items-center gap-2 rounded-lg border border-slate-100 bg-slate-50/70 px-3 py-2'>
            <p className='text-xs font-medium text-slate-600'>{t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.publish)}</p>
            <ToggleInput
              toggled={jobPostingData.active}
              handleToggle={handleToggle}
              name='Scatter'
              informationText={t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.disableEnable)}
            />
          </div>
        </div>
      </div>
      {renderTab()}
    </div>
  );
};

export default JobPosting;
